import * as TYPES from './constants';
import {API} from 'config/employer.config';
import {
  emergingTalentGraphError,
  requestEmergingTalentGraph,
  receiveEmergingTalentGraph,
} from './actions';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.EMERGING_TALENT_GRAPH_REQUEST:
      return {
        ...state,
        request: true,
      };
    case TYPES.EMERGING_TALENT_GRAPH_RECEIVE:
      return {
        ...state,
        request: false,
        data: action.payload,
      };
    case TYPES.EMERGING_TALENT_GRAPH_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.CLEAR_EMERGING_TALENT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const fetchEmergingTalentGraph = () => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();

  const end_point = `${API.administration.all_talents}`;

  const config = {
    mode: 'cors',
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({graph_metrics: true}),
  };

  dispatch(requestEmergingTalentGraph());

  return fetch(end_point, config)
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
      return res.json();
    })
    .then(data => {
      dispatch(receiveEmergingTalentGraph(data));
    })
    .catch(err => {
      console.log(err, 'fetch error');
      dispatch(emergingTalentGraphError(err));
    });
};
